import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Heart, GraduationCap, Compass, Sigma, Sparkles, ArrowRight } from "lucide-react";
import Seo from "../components/Seo";
import { Reveal } from "../components/Reveal";

const PATHS = [
  { icon: Heart, title: "Ebeveynliğimi geliştirmek istiyorum", to: "/programlar/bilgece-ebeveynlik", label: "Bilgece Ebeveynlik", desc: "Çocuğunla daha sağlıklı, bilinçli ve bilgece bir ilişki." },
  { icon: GraduationCap, title: "Öğretmenliğimi dönüştürmek istiyorum", to: "/programlar/bilgece-ogretmenlik-akademisi", label: "Öğretmenlik Akademisi", desc: "AI çağında öğrenciyi gören, öğrenmeyi tasarlayan öğretmenlik." },
  { icon: Compass, title: "Liderliğimi derinleştirmek istiyorum", to: "/programlar/bilgece-liderlik", label: "Bilgece Liderlik", desc: "İnsan, anlam, etik ve karar üzerine kurulu liderlik." },
  { icon: Sigma, title: "Çocuğumun öğrenmesini beslemek istiyorum", to: "/programlar/bilgece-matematik", label: "Bilgece Matematik", desc: "10–14 yaş için gerçek yaşam bağlantılı matematik." },
  { icon: Sparkles, title: "Kendimi dönüştürmek istiyorum", to: "/programlar/bilgece-atolye", label: "Bilgece Atölye", desc: "Birlikte düşünmenin ve deneyimlemenin mekânı." },
];

export default function Kesfet() {
  return (
    <>
      <Seo title="Keşfet — Yolculuğunu Seç" description="İhtiyacına göre doğru Bilgece programını bul. Ebeveynlik, öğretmenlik, liderlik, matematik ve kişisel dönüşüm." />
      <section className="pt-36 pb-16 bg-brand-green text-brand-offwhite grain relative overflow-hidden">
        <div className="container-narrow px-6 lg:px-10">
          <p className="text-xs uppercase tracking-[0.25em] text-brand-gold font-semibold mb-4">Yolculuğunu Seç</p>
          <h1 className="font-serif text-4xl md:text-6xl font-light">Bugün neyi dönüştürmek istiyorsun?</h1>
          <p className="text-brand-offwhite/75 mt-5 max-w-2xl leading-relaxed">Seni ürün adına göre değil, ihtiyacına göre yönlendiriyoruz. Aşağıdan sana en yakın yolu seç.</p>
        </div>
      </section>

      <section className="section-pad bg-brand-offwhite">
        <div className="container-narrow space-y-5">
          {PATHS.map((p, i) => {
            const Icon = p.icon;
            return (
              <Reveal key={i} delay={i * 0.06}>
                <Link to={p.to} data-testid={`kesfet-path-${i}`}
                  className="group flex flex-col sm:flex-row sm:items-center gap-6 bg-brand-cream border border-brand-gold-light/40 rounded-sm p-8 transition-colors hover:border-brand-gold">
                  <div className="w-14 h-14 rounded-full bg-brand-green flex items-center justify-center shrink-0">
                    <Icon className="text-brand-gold-light" size={26} strokeWidth={1.5} />
                  </div>
                  <div className="flex-1">
                    <h2 className="font-serif text-2xl md:text-3xl text-brand-green">{p.title}</h2>
                    <p className="text-brand-text/70 text-sm mt-1">{p.desc}</p>
                  </div>
                  <span className="inline-flex items-center gap-2 text-brand-green font-semibold text-sm shrink-0">
                    {p.label} <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                  </span>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </section>
    </>
  );
}
